// Small pure helpers for the Everyday Services screens.
import type { OperatorOption } from '../types';

/** E.164 ("+255712345678") or local ("0712 345 678") → digits the API expects ("255712345678"). */
export function phoneDigits(value: string | null | undefined, defaultDial = '255'): string {
  const raw = (value || '').trim();
  if (!raw) return '';
  if (raw.startsWith('+')) return raw.replace(/\D/g, '');
  const d = raw.replace(/\D/g, '');
  if (d.startsWith('0')) return defaultDial + d.slice(1);
  return d;
}

/** Any stored phone → E.164 for PhoneInput's value contract; '' if unusable. */
export function toE164(value: string | null | undefined, defaultDial = '255'): string {
  const d = phoneDigits(value, defaultDial);
  return d.length >= 9 ? `+${d}` : '';
}

/** A complete phone for the wallet/recipient: country code + subscriber number. */
export function isCompletePhone(digits: string): boolean {
  if (digits.startsWith('255')) return /^255\d{9}$/.test(digits);
  return /^\d{10,15}$/.test(digits);
}

/** Meter numbers: digits only, 6–20 long (the server's own bound). */
export function isMeterNumber(value: string): boolean {
  return /^\d{6,20}$/.test(value);
}

/** "12345678901234567890" → "1234 5678 9012 3456 7890" for reading aloud / typing. */
export function groupToken(token: string): string {
  return (token || '').replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ');
}

export function operatorName(code: string, operators: OperatorOption[]): string {
  if (!code) return '';
  const hit = operators.find((o) => o.code === code);
  if (hit) return hit.name;
  return code.charAt(0) + code.slice(1).toLowerCase();
}
